/*Package importing*/
import React, { useState } from 'react';

/*Import custom components and assets*/
import LoginWidget from './loginWidget';
import OTPWidget from './otpWidget';
import { identifyDatadogUser } from '../../datadog';

import logo from '../../assets/images/logo.png';
import loginHero from '../../assets/images/login-hero.svg';

const LoginMain = () => {
  const [loginWidget, setLoginWidget] = useState(true);
  const [data, setData] = useState({});

  const sendOTPSuccess = (otpData) => {
    setLoginWidget(false);
    setData(otpData);
  };

  const verifyOTPSuccess = (response) => {
    sessionStorage.setItem("zappUser", true);
    sessionStorage.setItem("accessToken", response.access_token);
    sessionStorage.setItem("data", JSON.stringify(response.data));
    sessionStorage.setItem("accessLevel", response.data.access_level);

    if (response.data.admin_permissions) {
      sessionStorage.setItem("permissions", JSON.stringify(response.data.admin_permissions));
    }

    identifyDatadogUser();

    // Redirect to intended page or dashboard
    const redirectPath = localStorage.getItem("redirectAfterLogin");
    localStorage.removeItem("redirectAfterLogin");
    window.location.href = redirectPath || '/dashboard';
  };

  return (
    <div className="e-body">
      <section className="e-login-section vh-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center mt-5">
              <img src={logo} alt="Tranna admin logo" className="e-logo mt-5" />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              {
                loginWidget ?
                  <LoginWidget sendOTPSuccess={sendOTPSuccess} />
                  :
                  <OTPWidget verifyOTPSuccess={verifyOTPSuccess} data={data} />
              }
            </div>
          
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoginMain;